import { RefObject } from "react";

import cn from "classnames";

import { Input } from "@/components/input/input.component";

import { brown } from "@/app/font";
import { ProductAccessoriesActionState } from "@/app/blu/shop/actions";
import { PDP_FORM_CATEGORY } from "@/app/blu/shop/constants";
import { GetKitPageAccessoriesQueryResult } from "@/sanity.types";

export const ConfiguratorAccessoriesNav = ({
  formRef,
  accessories,
  response,
}: ConfiguratorAccessoriesNavProps) => {
  const renderAccessoryGroups = () => {
    const navItems: NavItem[] = [];
    for (const item of accessories ?? []) {
      navItems.push({
        id: item?.id,
        name: item?.name,
        slug: item?.slug?.current,
      });
    }

    if (!navItems.length) return null;
    return navItems.map((item) => {
      const checked = response?.selectedCategory === item?.id;
      return (
        <li
          data-testid="configurator-accessories-filter-category"
          key={item.id}>
          <button
            type="button"
            value={item.name}
            data-testid="configurator-accessories-filter-category-button"
            aria-current={checked}
            onClick={() => {
              (
                formRef.current?.elements.namedItem(
                  PDP_FORM_CATEGORY,
                ) as HTMLInputElement
              ).value = item.id;

              formRef.current?.requestSubmit();
            }}
            className={cn(
              brown.className,
              "hover:text-secondary transition-border button flex border-b-[3px] py-2.5 whitespace-nowrap uppercase duration-300",
              {
                "text-greyscale-strength cursor-pointer border-transparent":
                  !checked,
                "text-secondary border-secondary": checked,
              },
            )}>
            <span
              data-testid="configurator-accessories-filter-category-label"
              className="px-[10px]">
              {item.name}
            </span>
          </button>

          <Input
            data-testid="configurator-accessories-filter-category-input"
            aria-label={`Select ${item.name} category`}
            type="radio"
            name={PDP_FORM_CATEGORY}
            id={item.id}
            value={item.id}
            className="hidden px-2.5"
            defaultChecked={checked}
            onClick={() => formRef.current?.requestSubmit()}
          />
        </li>
      );
    });
  };
  return (
    <section className="w-full max-w-full overflow-hidden">
      <ul
        data-testid="configurator-accessories-filter-fieldset"
        className="hide-scrollbar flex w-full flex-1 items-center gap-6 overflow-x-scroll">
        {renderAccessoryGroups()}
      </ul>
    </section>
  );
};

export type ConfiguratorAccessoriesNavProps = {
  formRef: RefObject<HTMLFormElement | null>;
  accessories?: NonNullable<GetKitPageAccessoriesQueryResult>["accessories"];
  response?: ProductAccessoriesActionState;
};

type NavItem = { id: string; name: string; slug?: string };
